import { ETargetPage, MainFiltersWidget } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { AddNewCardLayout } from '../../components/AddNewCard';
import { AddNewCardButton, AddNewCardButtonAB, ErrorMessageContainer } from './parts';

interface IAddNewCardProps {
  containerRef?: React.Ref<HTMLDivElement>;
  buttonRef?: React.Ref<HTMLDivElement>;
}

export const AddNewCardContainer: React.FC<IAddNewCardProps> = ({ containerRef, buttonRef }) => {
  const isExperimentGroupB = false; // Тут получение экспа
  const CardButtonComponent = isExperimentGroupB ? AddNewCardButtonAB : AddNewCardButton;

  return (
    <AddNewCardLayout containerRef={containerRef}>
      <MainFiltersWidget targetPage={ETargetPage.myHomePage} withRoomNumber={isExperimentGroupB} isMyHome={true} />
      <ErrorMessageContainer />
      <CardButtonComponent buttonRef={buttonRef} />
    </AddNewCardLayout>
  );
};
